import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { CompeonReverseClientInstance } from 'api';
import endpoints from 'api/CompeonReverseApi/endpoints';
import queryKeys from 'constants/queryKeys';

import { BfsDoiMutationResponse, BfsDoiMutationVariables } from '../BfsDoubleOptIn.model';

/**
 * Confirms a BfS marketing-consent Double-Opt-In (EBS-64). The applicant reaches
 * this via the link in the DOI email; the `token` comes from the URL query
 * string. On success (200, empty body) the BE marks the consent valid, pushes
 * the applicant to the DOI CleverReach list (ID 614979) and sets the `activated`
 * system field. A 403 means the token is invalid/expired (the grant link expires
 * after one week) and surfaces as the error state.
 *
 * This is a public link — authentication comes from the `token` in the body, not
 * from a session. It is sent on `CompeonReverseClientInstance`, whose auth
 * request interceptor adds no `Authorization` header when there is no session
 * (`getAuthorizationToken()` returns `{}`), so anonymous visitors send a bare
 * PATCH with a plain `{ token }` body. The BE deliberately rejects GET so
 * email-client link previews can't trigger it.
 */
export const useConfirmBfsDoi = createMutation<
  BfsDoiMutationResponse,
  BfsDoiMutationVariables,
  AxiosError
>({
  mutationKey: [queryKeys.bfs.confirmDoi],
  mutationFn: ({ token }) =>
    CompeonReverseClientInstance.patch(endpoints.CUSTOMERS.BFS_CONSENT_GRANT.compose(), { token }),
});
